import { Flex, Spinner, Text } from '@radix-ui/themes';

const LoadingIndicator = ({ text = null }) => {
    return (
        <Flex direction="column" align="center" justify="center" gap="2" width="100%" height="100%">
            <Spinner />
            {text && <Text size="2">{text}</Text>}
        </Flex>
    );
};

export default LoadingIndicator;
